import Image from "next/image";
import { useState } from "react";
import ArrowButton from "./arrowButton";

export default function Office({
  location,
  isSelected,
  setOfficeAddress,
}: any) {
  const [isHovered, setIsHovered] = useState(false);

  // split the address based on \n
  const address = location.locationDetails.address.split("\n");

  const handleClick = (location: string, country: string) => {
    setOfficeAddress(location, country);
  };

  return (
    <div
      className={`relative group flex flex-col px-4 md:px-8 xl:px-12 space-y-4 justify-center md:hover:cursor-pointer duration-300
                ${location.country === "Malaysia (HQ)"
          ? "min-h-[400px]"
          : "min-h-[300px]"
        } ${isSelected ? "bg-opacity-0" : "bg-white hover:bg-rainbow"
        } `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() =>
        handleClick(
          location.locationDetails.googleMapAddress,
          location.country
        )
      }
    >
      <h5
        className={`font-semibold text-lg  ${isSelected ? "text-cyan" : "text-purple"
          }`}
      >
        {location.country}
      </h5>
      <div
        className={`max-w-[85%] font-semibold text-lg text-darkGrey2 ${isSelected ? "text-white" : ""
          }`}
      >
        {/* {location.locationDetails.address} */}
        {/* render the address array */}
        {address.map((line: string, index: number) => (
          <div key={index} className="mb-0">
            {line}
          </div>
        ))}
      </div>
      <div className="mb-4">
        {location.locationDetails.contactNumber && (
          <div className="flex items-center gap-2">
            {isSelected ? (
              <Image
                src={"/mobile.svg"}
                alt="mobile icon"
                width={20}
                height={20}
              />
            ) : (
              <Image
                src={"/mobile-dark.svg"}
                alt="mobile icon"
                width={20}
                height={20}
              />
            )}
            <a
              href={`tel:${location.locationDetails.contactNumber.split(
                "/"
              )[0]
                }`}
              className={`phone-num mb-0 text-md font-medium text-darkGrey2  ${isSelected ? "text-white" : ""
                }`}
            >
              {location.locationDetails.contactNumber}
            </a>
          </div>
        )}
        {location.locationDetails.faxNumber && (
          <div className="flex items-center gap-2">
            {isSelected ? (
              <Image
                src={"/printer.svg"}
                alt="mobile icon"
                width={20}
                height={20}
              />
            ) : (
              <Image
                src={"/printer-dark.svg"}
                alt="mobile icon"
                width={20}
                height={20}
              />
            )}
            {/* <Image src={isHovered || isSelected ? "/printer.svg" : "/printer-dark.svg"} alt="mobile icon" width={20} height={20} /> */}
            <span
              className={`mb-0 text-md font-medium text-darkGrey2 ${isSelected ? "text-white" : ""
                }`}
            >
              {location.locationDetails.faxNumber}
            </span>
          </div>
        )}
        <div className="flex items-center gap-2">
          {isSelected ? (
            <Image
              src={"/mail.svg"}
              alt="mobile icon"
              width={20}
              height={20}
            />
          ) : (
            <Image
              src={"/mail-dark.svg"}
              alt="mobile icon"
              width={20}
              height={20}
            />
          )}
          <a
            href={`mailto:${location.locationDetails.email}`}
            className={`email-address mb-0 text-md font-medium text-darkGrey2 ${isSelected ? "text-white" : ""
              }`}
          >
            {location.locationDetails.email}
          </a>
        </div>
      </div>
      <ArrowButton
        active={isSelected}
        className={`!mt-0 ml-auto`}
        color={"purple"}
      />
    </div>
  );
}
